export function formatDateValue(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getRecentDateRange(months, today = new Date()) {
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  const start = new Date(end)
  // Clamp month-end dates instead of letting March 31 roll into March again.
  start.setDate(1)
  start.setMonth(start.getMonth() - months)
  const lastDay = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate()
  start.setDate(Math.min(end.getDate(), lastDay))
  return [start, end]
}

export function getRecentDateValues(months, today) {
  return getRecentDateRange(months, today).map(formatDateValue)
}

export function getMonthDateRange(value) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(value)) return []
  const [year, month] = value.split('-').map(Number)
  return [new Date(year, month - 1, 1), new Date(year, month, 0)]
}

export function getMonthOptions(today = new Date(), count = 36) {
  return Array.from({ length: count }, (_, index) => {
    const date = new Date(today.getFullYear(), today.getMonth() - index, 1)
    const value = formatDateValue(date).slice(0, 7)
    return { value, label: `${value.slice(0, 4)}年${value.slice(5)}月` }
  })
}

export function createDateRangePickerOptions() {
  return {
    shortcuts: [
      { text: '近一个月', months: 1 },
      { text: '近半年', months: 6 },
      { text: '近一年', months: 12 }
    ].map(({ text, months }) => ({
      text,
      onClick(picker) {
        picker.$emit('pick', getRecentDateRange(months))
      }
    }))
  }
}
